/*
Questo file consente di customizzare l'header dei CT per aggiungere dati o customizzare l'header dei CT creati ad hoc nel proprio progetto.
Sovrascrivere questo file nel progetto figlio ed implementare la propria logica per l'estensionde dell'header.*/

/* CUSTOMIZATIONS 
- Aggiunta condizione per il CT UnitaOrganizzativa
- Aggiunto il plugin Add to calendar per gli eventi
*/

import React from 'react';
import PropTypes from 'prop-types';
import UOPageHeader from '@package/components/View/UOView/UOPageHeader';
import { AddToCalendar } from '@package/components';

const PageHeaderExtend = ({ content }) => {
  switch (content['@type']) {
    case 'UnitaOrganizzativa':
      return <UOPageHeader content={content} />;
    case 'Event':
      return <AddToCalendar content={content} />;
    default:
      return <></>;
  }
};
export default PageHeaderExtend;

PageHeaderExtend.propTypes = {
  params: PropTypes.shape({
    content: PropTypes.object,
    readingtime: PropTypes.string,
    showreadingtime: PropTypes.bool,
    imageinheader: PropTypes.bool,
    imageinheader_field: PropTypes.string,
    showdates: PropTypes.bool,
    showtassonomiaargomenti: PropTypes.bool,
  }),
};
